"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditRentersCoverPriceOutputWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var core_1 = require("@athena-portal/core");
var components_1 = require("@athena-portal/components");
var commonFunctions_1 = require("../../../commonFunctions");
var EditRentersCoverPriceOutputWidget = exports.EditRentersCoverPriceOutputWidget = /** @class */ (function (_super) {
    __extends(EditRentersCoverPriceOutputWidget, _super);
    function EditRentersCoverPriceOutputWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.paymentRequired = _this.props.interaction.factors.additionalPremium > 0;
        _this.refundRequired = _this.props.interaction.factors.returnPremium > 0;
        _this.state = {};
        return _this;
    }
    EditRentersCoverPriceOutputWidget.prototype.componentDidMount = function () {
        var _this = this;
        this.customerPortalService.getPolicies(services_1.ProductsEnum.RENTERS).subscribe(function (policies) { return _this.setState({ policies: policies }); });
    };
    EditRentersCoverPriceOutputWidget.prototype.render = function () {
        if (this.state.policies) {
            return (React.createElement("div", { className: "_panel-dashboard form-group font-weight-extra-light text-center" },
                React.createElement("div", { id: "price", className: "fs-24 letter-spacing-n35 font-weight-bold font-family-display mb-2" },
                    this.paymentRequired && React.createElement(React.Fragment, null, (0, commonFunctions_1.getAmountToDisplay)(this.props.interaction.factors.additionalPremium)),
                    this.refundRequired && React.createElement(React.Fragment, null, (0, commonFunctions_1.getAmountToDisplay)(this.props.interaction.factors.returnPremium))),
                React.createElement("div", null,
                    this.paymentRequired && React.createElement(React.Fragment, null,
                        "to change ",
                        React.createElement("b", { className: "font-weight-semi-bold" }, this.renderWhatChangedWordings())),
                    this.refundRequired && React.createElement(React.Fragment, null,
                        "you will get refund to change ",
                        React.createElement("b", { className: "font-weight-semi-bold" }, this.renderWhatChangedWordings())),
                    !this.paymentRequired && !this.refundRequired && React.createElement(React.Fragment, null,
                        "Great news! There is no extra cost to change ",
                        this.renderWhatChangedWordings()))));
        }
        else {
            return React.createElement(components_1.Overlay, { show: true });
        }
    };
    EditRentersCoverPriceOutputWidget.prototype.renderWhatChangedWordings = function () {
        var changes = [];
        var prevCoverLimit = this.state.policies[0].interaction.factors.insuredValue;
        var newCoverLimit = this.props.interaction.factors.insuredValue;
        var prevExcess = this.state.policies[0].interaction.factors.excessAmount;
        var newExcess = this.props.interaction.factors.excessAmount;
        var prevAccidentalDamage = this.state.policies[0].interaction.factors.accidentalDamageProtection;
        var newAccidentalDamage = this.props.interaction.factors.accidentalDamageProtection;
        if (prevAccidentalDamage !== newAccidentalDamage) {
            changes.push("accidental damage");
        }
        if (prevCoverLimit !== newCoverLimit) {
            changes.push("contents cover limit from ".concat((0, commonFunctions_1.getAmountToDisplay)(prevCoverLimit), " to ").concat((0, commonFunctions_1.getAmountToDisplay)(newCoverLimit)));
        }
        if (prevExcess !== newExcess) {
            changes.push("excess from \u00A3".concat(prevExcess, " to \u00A3").concat(newExcess));
        }
        window.sessionStorage.removeItem("mtaEditRentersCoverChanges");
        window.sessionStorage.setItem("mtaEditRentersCoverChanges", changes.join(" and "));
        return changes.join(" and ");
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], EditRentersCoverPriceOutputWidget.prototype, "customerPortalService", void 0);
    return EditRentersCoverPriceOutputWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=EditRentersCoverPriceOutputWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/renters/EditRentersCoverPriceOutputWidget.js
// module id = 2575
// module chunks = 0